module.exports = __webpack_public_path__ + "create/static/media/avatar_Christian.600b55a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateExperience/Institucional/avatar_Christian.png
// module id = 479
// module chunks = 39